import useAuthorization from '@alltrails/context/hooks/useAuthorization';
import useUser from '@alltrails/context/hooks/useUser';
import { useAppSelector } from '@/utils/redux';

export function useHasCustomRouteEditPermission() {
  const user = useUser();
  const { hasPermission } = useAuthorization();
  const hasEditPermission = hasPermission({ permission: 'trails:manage' });
  const { id, routeOwner } = useAppSelector(state => ({
    id: state.customRoute.route.id,
    routeOwner: state.customRoute.map?.user
  }));

  return !id || user?.id === routeOwner?.id || hasEditPermission;
}
